export class Factory {
    Id: string;
    Name: string;
    Longitude: number;
    Latitude: number;
}